import { z } from "zod";

import { castToBool } from "../../../utils";

export const UpdateShopifyPricesRequestBodySchema = z.object({
  variationId: z.string().uuid().optional(),
});

export type UpdateShopifyPricesRequestBodyType = z.infer<
  typeof UpdateShopifyPricesRequestBodySchema
>;

export const UpdateShopifyPricesPathParamsSchema = z.object({
  experienceId: z.string().uuid(),
});

export type UpdateShopifyPricesPathParamsType = z.infer<
  typeof UpdateShopifyPricesPathParamsSchema
>;

export const UpdateShopifyPricesRequestQueryParamsSchema = z.object({
  saveToS3: castToBool.optional(),
});

export type UpdateShopifyPricesRequestQueryParamsType = z.infer<
  typeof UpdateShopifyPricesRequestQueryParamsSchema
>;
